<div class="minclt-border">
  <app-title-pages [titlePage]="titlePage" *ngIf="titlePage"></app-title-pages>

  <section class="flex justify-content-between align-items-center gap-1 mb-4 crud_general">
    <span class="minclt-descripcion">{{ descriptionPage }}</span>

    <div class="flex flex-row align-items-center gap-2">


      <app-boton-svg [nombre]="'agregar'" [color]="'verde-lima'" [size]="'25'" [borderRadius]="'8'"
        *ngIf="textButtonAdd" (click)="onClickButtonAdd.emit()" class="md:hidden"></app-boton-svg>

      <app-boton-svg [nombre]="'lupa'" [color]="'morado'" [size]="'25'" [borderRadius]="'8'"
        *ngIf="filterInputText.show || filterInputSelect.show || questionsFilterForm.length > 0"
        (click)="onShowFormDialog()" class="md:hidden"></app-boton-svg>
    </div>


  </section>

  <!-- Permite agregar un tablero indicador o algun elemento en el header -->
  <ng-content></ng-content>

  <form *ngIf="!showDinamicFilterForm" [formGroup]="formFilter" class="formgroup-inline hidden md:flex mb-5"
    autocomplete="off">
    <div *ngIf="filterInputText.show" class="field">
      <label htmlFor="filterInputText" class="p-sr-only">{{ filterInputText.label }}</label>
      <input *ngIf="filterInputText.type === undefined" id="filterInputText" pInputText class="minclt-input" type="text"
        formControlName="filterText" [placeholder]="filterInputText.label" />
      <p-inputNumber *ngIf="filterInputText.type === 'number'" class="minclt-input" id="filterInputText"
        formControlName="filterText" [placeholder]="filterInputText.label" />
    </div>
    <div *ngIf="filterSecondaryInputText.show" class="field">
      <label htmlFor="filterSecondaryInputText" class="p-sr-only">{{ filterSecondaryInputText.label }}</label>
      <input id="filterSecondaryInputText" pInputText class="minclt-input" id="filterSecondaryInputText" type="text"
        formControlName="filterSecondaryText" [placeholder]="filterSecondaryInputText.label" />
    </div>
    <div *ngIf="filterInputSelect.show" class="field">
      <label htmlFor="filterInputSelect" class="p-sr-only">{{ filterInputSelect.label }}</label>
      <p-dropdown class="minclt-p-dropdown" id="filterInputSelect" [options]="filterInputSelect.options"
        optionLabel="text" formControlName="filterSelect" optionValue="value" [placeholder]="filterInputSelect.label"
        [filter]="true" />
    </div>
    <div *ngIf="filterSecondaryInputSelect.show" class="field">
      <label htmlFor="filterSecondaryInputSelect" class="p-sr-only">{{ filterSecondaryInputSelect.label }}</label>
      <p-dropdown class="minclt-p-dropdown" id="filterSecondaryInputSelect"
        [options]="filterSecondaryInputSelect.options" optionLabel="text" formControlName="filterSecondarySelect"
        optionValue="value" [placeholder]="filterSecondaryInputSelect.label" [filter]="true" />
    </div>

    <div *ngIf="filterThirdInputSelect.show" class="field">
      <label htmlFor="filterThirdInputSelect" class="p-sr-only">{{ filterThirdInputSelect.label }}</label>
      <p-dropdown class="minclt-p-dropdown" id="filterThirdInputSelect" [options]="filterThirdInputSelect.options"
        optionLabel="text" formControlName="filterThirdSelect" optionValue="value"
        [placeholder]="filterThirdInputSelect.label" [filter]="true" />
    </div>

    <div *ngIf="filterFourthInputSelect.show" class="field">
      <label htmlFor="filterFourthInputSelect" class="p-sr-only">{{ filterFourthInputSelect.label }}</label>
      <p-dropdown class="minclt-p-dropdown" id="filterFourthInputSelect" [options]="filterFourthInputSelect.options"
        optionLabel="text" formControlName="filterFourthSelect" optionValue="value"
        [placeholder]="filterFourthInputSelect.label" [filter]="true" />
    </div>

    <div *ngIf="filterInputDate.show" class="field">
      <label class="font-semibold" htmlFor="filterInputDate" class="p-sr-only">{{ filterInputDate.label }}</label>
      <p-calendar formControlName="filterDate" [selectionMode]="filterInputDate.type" [readonlyInput]="true"
        [placeholder]="filterInputDate.label" />
    </div>

    <section class="flex gap-2 mb-1 md:mb-1 crud_general">
      <ng-container *ngFor="let btn of btnsCrudBasic">
        <p-button severity="primary" [label]="btn.label" (click)="onbtnsCrudBasic.emit(btn.id)" />
      </ng-container>
      <p-button *ngIf="filterInputText.show || filterInputSelect.show" severity="primary" label="Buscar"
        (click)="onSubmitFilterForm.emit(formFilter)" />
      <p-splitButton *ngIf="buttonsActionsList.length > 0" label="Más acciones" [model]="buttonsActionsList" />
      <app-boton-svg [nombre]="'restaurar'" [color]="'amarillo'" [size]="'35'" [borderRadius]="'8'"
        *ngIf="filterInputText.show || filterInputSelect.show" (click)="onClickClearFilter()"
        [pTooltip]="'Limpiar busqueda'" tooltipPosition="bottom"></app-boton-svg>
      <app-boton-svg [nombre]="'agregar'" [color]="'verde-lima'" [size]="'35'" [borderRadius]="'8'"
        *ngIf="textButtonAdd" (click)="onClickButtonAdd.emit()" [pTooltip]="'Agregar ' + titlePage"
        tooltipPosition="bottom"></app-boton-svg>
    </section>
  </form>
  <div class="hidden md:block">
    <app-form-print *ngIf="showDinamicFilterForm" [questions]="questionsFilterForm" [textButtonSubmit]="'Buscar'"
      [hideAlertToSubmit]="true" [formFilter]="true" [showClearFilters]="showClearFiltersFormDynamic"
      (sendQuestions)="onSubmitFilterForm.emit($event)">
      <p-splitButton *ngIf="buttonsActionsList.length > 0" label="Más acciones" [model]="buttonsActionsList" />
    </app-form-print>

  </div>
  <app-basic-table [columnsTable]="columnsTable" [dataTable]="dataTable" [actionsTable]="actionsTable"
    [configPaginator]="configPaginator" (onClickButtonTable)="onClickButtonTable.emit($event)"
    (onChangePaginator)="onChangePaginator.emit($event)" [colorearColumna]="['Acciones']"></app-basic-table>
</div>